import React from 'react';

import SkillPill from '@/modules/corporate/components/SkillPill';
import useSkills from '@/modules/skills/hooks/useSkills';

function SelectedSkills({ skillIds }: { skillIds: string[] }) {
  const { skills, fetching } = useSkills({ ids: skillIds });

  if (!skillIds?.length || fetching || !skills?.length) {
    return null;
  }

  return (
    <>
      {skills.map((skill) => (
        <SkillPill key={skill.id} skill={skill} />
      ))}
    </>
  );
}

export default SelectedSkills;
